function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function watchInstagramFeed() {
  const source = document.querySelector('#insta-feed');
  const instaFeed = document.createElement('slider-component');
  instaFeed.classList.add('instafeed__slider', 'slider-mobile-gutter', 'slider-component-desktop');
  instaFeed.setAttribute('autoplay', 'true');

  instaFeed.innerHTML = `
    <ul id='Slider-insta-feed' class='grid grid--5-col-desktop grid--1-col-tablet-down slider slider--desktop slider--tablet grid--peek'></ul>
  `;

  const list = instaFeed.querySelector('ul');

  const onItemClick = (link, event) => {
    event.preventDefault();
    const target = document.querySelector(`[data-instafeed-close-id="${link.hash.replace('#', '')}"]`);

    const slider = link.closest('slider-component');

    if (slider.dragging) {
      return;
    }

    if (target) {
      target.setAttribute('style', 'display: block!important');
    }
  }

  if (!source) return;

  const addEventListeners = () => {
    list.querySelectorAll('a').forEach((link) => {
      if (!link.initialized) {
        link.initialized = true;
        link.addEventListener('click', onItemClick.bind(this, link));
      }
    });
  };

  const updateInstaFeed = () => {
    const carouselItems = Array.from(source.querySelectorAll('.instafeed-new-layout-item'));

    if (carouselItems.length > 0) {
      const slides = carouselItems.map((item) => {
        const image = item.querySelector('img');
        const link = item.querySelector('.instafeed-new-layout-item-container');
        const slide = document.createElement('li');
        slide.classList.add('grid__item', 'slider__slide');
        slide.innerHTML = `
          <a href='#${link?.dataset.instafeedOpenId}' class='instafeed__link'>
            <img width='350' height='350' src='${image?.dataset?.src}' alt='${image?.alt}' loading='lazy' />
            <span class='instafeed__link-overlay'>
              <svg width='38' height='38' fill="none" viewBox="0 0 38 38">
                <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" d="M1 13.6v10.8C1 33.4 4.6 37 13.6 37h10.8c9 0 12.6-3.6 12.6-12.6V13.6C37 4.6 33.4 1 24.4 1H13.6C4.6 1 1 4.6 1 13.6Z"/>
                <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" d="M19 25.3a6.3 6.3 0 1 0 0-12.6 6.3 6.3 0 0 0 0 12.6Z"/>
              </svg>
            </span>
          </a>
        `;

        return slide;
      });

      list.innerHTML = '';
      list.append(...slides);
    }
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        updateInstaFeed();
      }
    });
  });

  observer.observe(source, { childList: true, subtree: true });

  const sliderObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        addEventListeners();
      }
    });
  });

  sliderObserver.observe(list, { childList: true });

  // insert new feed after source
  source.insertAdjacentElement('afterend', instaFeed);
}

watchInstagramFeed();

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.autoplay = this.getAttribute('autoplay') === 'true' || false;
    this.slides = [];
    this.clones = [];
    this.firstClone = null;
    this.state = 'paused';

    this.initSlider();
    this.slider.addEventListener('scroll', this.update.bind(this), false);

    if (this.autoplay && this.slider) {
      this.play();

      this.slider.addEventListener('mouseenter', this.pause.bind(this));
      this.slider.addEventListener('mouseleave', this.play.bind(this));
    }

    // if is not touch device
    if (!('ontouchstart' in window)) {
      this.scrollTimeConstant = 325;
      this.scrollTicker = null;
      this.scrollTimestamp = null;
      this.dragStartRef = null;
      this.scrollAmplitude = null;
      this.scrollVelocity = null;
      this.scrollFrame = null;
      this.scrollOffset = 0;
      this.slider.addEventListener('mousedown', this.onDragStart.bind(this));
      this.slider.addEventListener('mouseup', this.onDragEnd.bind(this));
      this.onDragHandler = this.onDrag.bind(this);

      this.slider.querySelectorAll('a').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (this.dragging) {
            event.preventDefault();
            return false;
          }
        });
      });
    }

    if (!this.slider || this.autoplay || !this.nextButton) return;

    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  onDragStart(event) {
    event.preventDefault();
    event.stopPropagation();

    this.dragging = false;
    this.slider.style.scrollSnapType = 'inherit';
    this.dragStartRef = event.clientX;
    this.dragStart = event.clientX;
    this.scrollVelocity = this.scrollAmplitude = 0;
    this.scrollOffset = this.slider.scrollLeft;
    this.scrollFrame = this.scrollOffset;
    this.scrollTimestamp = Date.now();
    this.autoScrollTarget = null;
    this.isAutoScrolling = false;
    clearInterval(this.scrollTicker);
    this.scrollTicker = setInterval(this.track.bind(this), 100);

    this.slider.addEventListener('mousemove', this.onDragHandler);
  }

  track() {
    const now = Date.now();
    const elapsed = now - this.scrollTimestamp;
    this.scrollTimestamp = now;
    const delta = this.scrollOffset - this.scrollFrame;
    this.scrollFrame = this.scrollOffset;

    const v = 1000 * delta / (1 + elapsed);
    this.scrollVelocity = 0.8 * v + 0.2 * this.scrollVelocity;
  }

  onDragEnd(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.scrollVelocity > 10 || this.scrollVelocity < -10) {
      this.isAutoScrolling = true;
      this.scrollAmplitude = 0.8 * this.scrollVelocity;
      this.autoScrollTarget = Math.max(0, Math.round(this.scrollOffset + this.scrollAmplitude));
      this.scrollTimestamp = Date.now();

      if (this.scrollOffset > 0) {
        requestAnimationFrame(this.dragAutoScroll.bind(this));
      }
    } else {
      this.scrollToClosest();
    }

    clearInterval(this.scrollTicker);

    setTimeout(() => {
      this.dragging = false;
    }, 200);

    this.slider.removeEventListener('mousemove', this.onDragHandler);
    return false;
  }

  scrollToClosest() {
    const scrollPosition = this.slider.scrollLeft;
    const closestSlide = this.slides.reduce((prev, curr) => {
      return Math.abs(curr.offsetLeft - scrollPosition) < Math.abs(prev.offsetLeft - scrollPosition) ? curr : prev;
    });
    const slidesGap = getComputedStyle(this.slider).scrollPaddingLeft;
    this.slider.scrollTo({
      left: closestSlide.offsetLeft - parseInt(slidesGap),
    });

    setTimeout(() => {
      this.slider.style.scrollSnapType = null;
    }, 500);
  }

  dragScroll(pos) {
    this.scrollOffset = pos;
    this.slider.scrollTo({
      left: this.scrollOffset,
      behavior: 'instant',
    });
  }

  dragAutoScroll() {
    const pos = Math.round(this.slider.scrollLeft) + this.slider.clientWidth;

    if (this.slider.scrollWidth - pos < 1) {
      this.scrollAmplitude = 0;
    }

    // if (this.scrollAmplitude) {
    //   const elapsed = Date.now() - this.scrollTimestamp;
    //   const delta = -this.scrollAmplitude * Math.exp(-elapsed / this.scrollTimeConstant);
    //
    //   if (delta > 0.5 || delta < -0.5) {
    //     this.dragScroll(this.autoScrollTarget + delta);
    //     requestAnimationFrame(this.dragAutoScroll.bind(this));
    //   } else {
    //     this.isAutoScrolling = false;
    //     this.dragScroll(this.autoScrollTarget);
    //     this.scrollToClosest();
    //   }
    // } else {
    //   this.isAutoScrolling = false;
      this.scrollToClosest();
    // }
  }

  onDrag(event) {
    const pos = event.clientX;
    const delta = this.dragStartRef - pos;

    if (delta > 2 || delta < -2) {
      this.dragStartRef = pos;
      this.dragScroll(this.scrollOffset + delta);
    }

    if (this.dragStart - event.clientX > 20 || this.dragStart - event.clientX < -20) {
      this.dragging = true;
    }
  }

  initSlider() {
    const updateSlides = () => {
      this.slides = Array.from(this.slider.children).filter((el) => !el.classList.contains('is--clone'));
      this.firstClone = this.slider.querySelector('.is--clone');
    };

    if (this.autoplay) {
      this.mutationObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          const addedNodes = Array.from(mutation.addedNodes);
          if (addedNodes.length > 0 && !addedNodes[0].classList.contains('is--clone')) {
            updateSlides();
            this.updateInfinitySlider();
          }
        });
      });

      this.mutationObserver.observe(this.slider, { childList: true });

      const intersectionObserver = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.play();
        } else {
          this.pause();
        }
      });

      intersectionObserver.observe(this);
    }

    updateSlides();

    this.resizeObserver = new ResizeObserver((entries) => {
      if (this.autoplay) {
        this.updateInfinitySlider();
      } else if (this.nextButton) {
        this.initPages();
      }
    });

    this.resizeObserver.observe(this.slider);
  }

  updateInfinitySlider = () => {
    const width = this.slider.clientWidth;
    let clonesWidth = 0;
    let clones = [];
    this.slider.querySelectorAll('.is--clone').forEach((clone) => clone.remove());

    if (width === 0) return;

    for (let slide of this.slides) {
      const slideWidth = slide.clientWidth;
      const clone = slide.cloneNode(true);
      clone.classList.add('is--clone');
      clonesWidth += slideWidth;
      clones.push(clone);

      if (clonesWidth >= width) {
        break;
      }
    }

    this.slider.append(...clones);
    this.slides = Array.from(this.slider.children).filter((el) => !el.classList.contains('is--clone'));
    this.firstClone = this.slider.querySelector('.is--clone');
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  play() {
    this.slider.style.scrollSnapType = 'inherit';

    if (this.state === 'paused') {
      this.state = 'playing';
      window.requestAnimationFrame(this.animateScroll.bind(this));
    }
  }

  pause() {
    this.state = 'paused';
  }

  animateScroll() {
    if (this.state === 'paused') return;

    this.slider.scrollTo({ left: this.slider.scrollLeft + 1, behavior: 'instant' });
    window.requestAnimationFrame(this.animateScroll.bind(this));
  }

  update() {
    const sliderScrollPosition = this.slider.scrollLeft;

    if (this.autoplay && !this.isAutoScrolling) {
      const firstSlidePosition = this.slides[0]?.offsetLeft;
      const firstClonePosition = this.firstClone?.offsetLeft;

      if (
        firstClonePosition !== undefined
        && firstSlidePosition !== undefined
        && sliderScrollPosition >= firstClonePosition - firstSlidePosition) {
        this.slider.scrollTo({
          left: 0,
          behavior: 'instant',
        });
      }

      return;
    }

    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(sliderScrollPosition / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage !== previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && sliderScrollPosition === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  goToSlide(slideNumber) {
    this.slideScrollPosition = (slideNumber - 1) * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition, true);
  }

  setSlidePosition(position, instant = false) {
    this.slider.scrollTo({
      left: position,
      behavior: instant ? 'instant' : 'smooth',
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const madeTimeSource = html.getElementById(
          `MadeTime-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const madeTimeDestination = document.getElementById(`MadeTime-${this.dataset.section}`);

        const leadTimeSource = html.getElementById(
          `Lead-time-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const leadTimeDestination = document.getElementById(`Lead-time-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (madeTimeSource && madeTimeDestination) madeTimeDestination.innerHTML = madeTimeSource.innerHTML;
        if (leadTimeSource && leadTimeDestination) {
          leadTimeDestination.hidden = leadTimeSource.hidden;
        }
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(`[id="product-form-${this.dataset.section}"]`);

    productForms.forEach((productForm) => {
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) {
          addButton.dataset.text = text;
          addButtonText.textContent = text;
        }
      } else {
        addButton.removeAttribute('disabled');
        addButton.dataset.text = window.variantStrings.addToCart;
        addButtonText.textContent = window.variantStrings.addToCart;
      }
    });
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class HeroComponent extends HTMLElement {
  #keyframes = [
    { opacity: '1' },
    { opacity: '0' },
  ];

  #timing = {
    duration: 1000,
    iterations: 1,
    fill: 'forwards',
    easing: 'ease-out',
  };
  constructor() {
    super();

    this.current = 0;
    this.paused = true;
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.hero__slide'));
    this.loader = this.querySelector('.hero__loader');

    const imagesLoaded = this.slides.map((slide) => {
      const image = slide.querySelector('img');
      return new Promise((resolve, reject) => {
        if (image.complete) {
          resolve();
        } else {
          image.addEventListener('load', resolve);
          image.addEventListener('error', reject);
        }
      });
    });

    Promise.all(imagesLoaded).then(() => {
      this.classList.add('hero--loaded');
      this.initSlider();
    });

    this.slides.forEach((slide) => {
      slide.hidden = false;
    });
  }

  initSlider() {
    if (!this.loader) {
      return this.loaded();
    }

    const svg = this.loader.querySelector('svg');
    const image = this.loader.querySelector('img');

    if (svg) {
      svg.animate(this.#keyframes, {
        ...this.#timing,
        delay: 3000,
      }).onfinish = () => {
        if (!image) {
          return this.loaded();
        }

        image.animate(this.#keyframes, {
          ...this.#timing,
          delay: 1500,
        }).onfinish = () => {
          this.loaded();
        };
      };
    }
  }

  loaded() {
    if (this.loader) {
      this.loader.remove();
    }

    new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && this.paused) {
        this.play();
        this.paused = false;
      } else if (!entries[0].isIntersecting && !this.paused) {
        this.paused = true;
      }
    }).observe(this);
  }

  play() {
    const currentSlide = this.slides[this.current];
    const next = (this.current + 1) % this.slides.length;
    const nextSlide = this.slides[next];

    currentSlide.classList.add('hero__slide--active');
    nextSlide.classList.add('hero__slide--next');

    const animation = currentSlide.animate(this.#keyframes, { ...this.#timing, delay: 1500 });

    animation.onfinish = (a) => {
      currentSlide.classList.remove('hero__slide--active');
      nextSlide.classList.remove('hero__slide--next');
      nextSlide.classList.add('hero__slide--active');
      this.current = next;
      animation.cancel();

      if (!this.paused) {
        this.play();
      }
    }
  }
}

customElements.define('hero-component', HeroComponent);


class ElephantAnimation extends HTMLElement {
  constructor() {
    super();

    this.circles = this.querySelectorAll('circle');
    this.activeIndex = 0;
    this.direction = 'forward';
  }

  connectedCallback() {
    this.play();
  }

  play() {
    const active = this.circles[this.activeIndex];

    if (this.direction === 'forward') {
      this.activeIndex = (this.activeIndex + 1) % this.circles.length;
    } else {
      this.activeIndex = (this.activeIndex - 1) % this.circles.length;
    }

    active.classList.add('active');

    if (this.activeIndex === 0) {
      this.direction = 'forward';
    } else if (this.activeIndex === this.circles.length - 1) {
      this.direction = 'backward';
    }

    setTimeout(() => active.classList.remove('active'), 1000);
    setTimeout(() => this.play(), 1200);
  }
}

customElements.define('elephant-animation', ElephantAnimation);

class ElephantWink extends HTMLElement {
  constructor() {
    super();
    this.eye = this.querySelector('.elephant__eye');
    this.eyeWink = this.querySelector('.elephant__eye-wink');
    this.mode = this.getAttribute('mode') || 'none';
  }

  connectedCallback() {
    if (this.mode === 'winking') {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.play();
        } else {
          this.pause();
        }
      });

      observer.observe(this);
    }
  }

  pause() {
    clearInterval(this.interval);
  }

  play() {
    this.interval = setInterval(() => {
      this.wink();
    }, 4000);
  }

  wink() {
    this.eye.classList.add('hidden');
    this.eyeWink.classList.remove('hidden');

    setTimeout(() => {
      this.eye.classList.remove('hidden');
      this.eyeWink.classList.add('hidden');
    }, 1000);
  }
}

customElements.define('elephant-wink', ElephantWink);

class LookbookList extends HTMLElement {
  constructor() {
    super();

    this.buttons = this.querySelectorAll('.lookbook-list__card-button');

    if (this.buttons.length === 0) return;

    this.init();
    this.buttons.forEach((button, index) => {
      button.addEventListener('click', (event) => this.onClick(event, index + 1));
    })
  }

  init() {
    this.modal = document.createElement('lookbook-modal');
    this.modal.classList.add('lookbook-modal');

    document.body.appendChild(this.modal);
  }

  onClick(event, index) {
    this.modal.open(index);
  }
}

customElements.define('lookbook-list', LookbookList);

class LookbookModal extends HTMLElement {
  constructor() {
    super();

    this.activeLook = this.getAttribute('current') || 0;
    this.innerHTML = `
      <div class="lookbook-modal__content">
        <div class='lookbook-modal__products'>
          <ul>
            ${this.renderProductsList().join('')}
          </ul>
        </div>
        <div class='lookbook-modal__slider-wrapper'>
          <slider-component class="lookbook-modal__slider slider-mobile-gutter slider-component-desktop">
            <button type="button" class="slider-button slider-button--prev" name="previous">
              <svg width="26" height='40' viewBox="0 0 28 42">
                <path stroke="#808285" stroke-miterlimit="10" stroke-width=".5" d="m26.9 41 .1-.1L1.3 21 27 1.1l-.1-.1L1 21 27 41Z"/>
              </svg>
            </button>
            <ul id='Slider-${window.lookbooks.id}' class='grid grid--1-col-desktop grid--1-col-tablet-down slider slider--desktop slider--tablet grid--peek'>
              ${window.lookbooks.looks.map((look) => (
                `<li id='Slide-${window.lookbooks.id}' class="grid__item slider__slide">
                  <img src='${look.image}' alt='${window.lookbooks.title} ${window.lookbooks.year}' loading='lazy' />
                </li>`
              )).join('')}
            </ul>
            <button type="button" class="slider-button slider-button--next" name="next">
              <svg width="26" height='40' viewBox="0 0 28 42">
                <path stroke="#121212" stroke-miterlimit="10" d="m1.1 41-.1-.1L26.7 21 1 1.1l.1-.1L27 21 1 41Z"/>
              </svg>
            </button>
          </slider-component>
        </div>
        <div class='lookbook-modal__info'>
          <h2 class='lookbook-modal__info-title'>
            ${window.lookbooks.title}
            <strong>${window.lookbooks.year}</strong>
          </h2>
          <h3 class='lookbook-modal__info-subtitle'>
            ${window.lookbooks.i18n.look}
            <strong>
              <span class='lookbook-modal__info-current'>${this.activeLook + 1}</span>/<span class='lookbook-modal__info-total'>${window.lookbooks.looks.length}</span>
            </strong>  
          </h3>
          <button type='button' class='link lookbook-modal__close'>
            <span>${window.lookbooks.i18n.viewAll}</span>
            <svg width='20' height='20' fill="none" viewBox="0 0 22 22">
              <path stroke="#121212" stroke-miterlimit="10" stroke-width=".5" d="m1 1 20 20M21 1 1 21"/>
            </svg>
          </button>
        </div>
      </div>
    `;

    this.slider = this.querySelector('slider-component');

    this.slider.addEventListener('slideChanged', (event) => {
      this.setAttribute('current', event.detail.currentPage - 1);
    });
    this.querySelector('.lookbook-modal__close').addEventListener('click', this.onCloseClick.bind(this));

    const hash = window.location.hash.replace('#look-', '');

    if (hash) {
      this.open(parseInt(hash));
    }
  }

  static get observedAttributes() { return ['current']; }

  renderProductsList() {
    return window.lookbooks.looks[this.activeLook].products.map((product) => (
      `<li>
        <a href='${product.url}' class='lookbook-modal__product'>
          ${product.title}
        </a>
      </li>`
    ));
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'current') {
      this.activeLook = newValue;
      this.update();
    }
  }

  update() {
    const newId = parseInt(this.activeLook) + 1;
    this.querySelector('.lookbook-modal__info-current').textContent = newId;
    this.querySelector('.lookbook-modal__products ul').innerHTML = this.renderProductsList().join('');
    window.location.hash = `look-${newId}`;
  }

  onCloseClick() {
    this.closeModal();
  }

  open(slide = 0) {
    this.classList.add('is--opening');
    document.scrollingElement.style.overflow = 'hidden';

    setTimeout(() => {
      console.log(slide);
      this.slider.goToSlide(slide);
      this.classList.add('is--opened');
    }, 100);
  }

  closeModal() {
    document.scrollingElement.style.overflow = '';
    this.classList.remove('is--opened');
    window.location.hash = '';

    setTimeout(() => {
      this.classList.remove('is--opening');
    }, 500);
  }
}

customElements.define('lookbook-modal', LookbookModal);

class FloatingTimer extends HTMLElement {
  constructor() {
    super();

    if (!this.getAttribute('date')) return;

    this.targetDate = new Date(this.getAttribute('date'));
    this.parts = this.querySelectorAll('.timer__part');
    this.timerState = {
      days: 0,
      hours: 0,
      minutes: 0,
    };

    this.update();
    this.interval = setInterval(this.update.bind(this), 1000);
  }

  update() {
    const now = new Date();
    const difference = this.targetDate - now;

    if (difference <= 0) {
      clearInterval(this.interval)
    }

    this.timerState.days = Math.floor(difference / (1000 * 60 * 60 * 24));
    this.timerState.hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    this.timerState.minutes = Math.floor((difference / (1000 * 60)) % 60);
    this.timerState.seconds = Math.floor((difference / 1000) % 60);
    this.render();
  }

  render() {
    this.parts.forEach((part) => {
      const digits = part.querySelectorAll('.timer__number');
      const value = this.timerState[part.dataset.unit]
        .toString()
        .padStart(digits.length, '0')
        .slice(-digits.length);

      digits.forEach((digit, index) => {
        const digitState = digit.dataset.state || 0;
        const size = digit.dataset.size || 11;

        if (digitState === value[index] || value[index] === '0' && digitState === `${size - 1}`) return;

        const track = digit.querySelector('.timer__number-track');

        track.animate([
          { transform: `translateY(calc(-100% / ${size} * ${digitState}))` },
          { transform: `translateY(calc(-100% / ${size} * ${value[index]}))` },
        ], {
          duration: 500,
          fill: 'forwards',
          easing: 'ease-in-out',
        }).onfinish = () => {
          if (value[index] === '0') {
            track.animate([
              { transform: `translateY(calc(-100% / ${size} * ${value[index]}))` },
              { transform: `translateY(calc(-100% / ${size} * ${size - 1})` },
            ], {
              duration: 0,
              fill: 'forwards',
            });
            digit.dataset.state = `${size - 1}`;
          } else {
            digit.dataset.state = value[index];
          }
        };
      });
    });
  }
}

customElements.define('floating-timer', FloatingTimer);

class RedDots extends HTMLElement {
  constructor() {
    super();

    this.dots = this.querySelectorAll('.red-dots__dot');
    this.activeDot = -1;

    if (this.dots.length > 0) {
      this.dots = Array.from(this.dots);
      this.dots.reverse();
      this.update();
      setInterval(this.update.bind(this), 2000);
    }

  }
  update() {
    this.dots[this.activeDot]?.classList.remove('is--active');
    this.activeDot = (this.activeDot + 1) % this.dots.length;
    this.dots[this.activeDot].classList.add('is--active');
  }
}

customElements.define('red-dots', RedDots);

class CopyToClipboard extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.copy.bind(this));
  }

  copy() {
    const value = this.getAttribute('value');
    const message = this.getAttribute('message');

    if ('permissions' in navigator) {
      navigator.permissions.query({ name: "clipboard-write" }).then((result) => {
        if (result.state === "granted" || result.state === "prompt") {
          navigator.clipboard.writeText(value).then(() => {
            this.classList.add('is--copied');
            setTimeout(() => this.classList.remove('is--copied'), 1000);
          }, (err) => {
            console.error('Could not copy text: ', err);
          });
        }
      });
    } else {
      this.fallbackCopyTextToClipboard(value);
    }

    this.classList.add('is--copied');
    this.innerHTML = message;

    setTimeout(() => {
      this.classList.remove('is--copied');
      this.innerHTML = value;
    }, 1000);
  }

  fallbackCopyTextToClipboard(text) {
    const input = document.createElement('textarea');
    input.value = text;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    input.remove();
  }
}

customElements.define('copy-to-clipboard', CopyToClipboard);

class GoToTop extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.scrollToTop.bind(this));

    // Hide the button if the page is 300px from the top
    if (window.scrollY > 300) {
      this.classList.remove('hidden');
    }

    window.addEventListener('scroll', () => {
      if (window.scrollY > 300) {
        this.classList.remove('hidden');
      } else {
        this.classList.add('hidden');
      }
    });
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}

customElements.define('go-to-top', GoToTop);
